import { http } from '@/core/api';

export const getByParameterName = (parameterName) =>
  http.get(`api/sysparameter/byparametername`, {
    params: { parameterName },
  });
